import { render, staticRenderFns } from "./CourierTabLinks.vue?vue&type=template&id=6ff1bad2"
import script from "./CourierTabLinks.vue?vue&type=script&lang=js"
export * from "./CourierTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports